import React from 'react';
import './Card.css';

/**
 * Reusable Card Component
 *
 * @param {string} variant - 'default' | 'glass' | 'solid' | 'outlined'
 * @param {string} padding - 'none' | 'sm' | 'md' | 'lg'
 * @param {boolean} hoverable - Add hover effect
 * @param {function} onClick - Click handler
 * @param {string} className - Additional CSS classes
 */
function Card({
  children,
  variant = 'glass',
  padding = 'md',
  hoverable = false,
  onClick,
  className = '',
  ...props
}) {
  const classes = [
    'card-ui',
    `card-${variant}`,
    `card-padding-${padding}`,
    hoverable && 'card-hoverable',
    onClick && 'card-clickable',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} onClick={onClick} {...props}>
      {children}
    </div>
  );
}

/**
 * Card Header Component
 */
export function CardHeader({ children, className = '', ...props }) {
  return (
    <div className={`card-header ${className}`} {...props}>
      {children}
    </div>
  );
}

/**
 * Card Body Component
 */
export function CardBody({ children, className = '', ...props }) {
  return (
    <div className={`card-body ${className}`} {...props}>
      {children}
    </div>
  );
}

/**
 * Card Footer Component
 */
export function CardFooter({ children, className = '', ...props }) {
  return (
    <div className={`card-footer ${className}`} {...props}>
      {children}
    </div>
  );
}

export default Card;
